import React, { useCallback, useEffect, useState } from "react";
import JumboContentLayout from "@jumbo/components/JumboContentLayout";
import PagesFiltersToolsBar from "../components/PagesFiltersToolsBar";
import Swal from "sweetalert2";
import PaginationComponent from "../components/Pagination";
import EmptyListWarning from "../components/EmptyListWarning/EmptyListWarning";
import { useAPI } from "app/hooks/useApi";
import HeaderPages from "../components/HeaderPages";
import EnvolvidosListCard from "../components/EnvolvidosListCard";

const Envolvidos = () => {
  const [count, setCount] = useState(100);
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [sortBy, setSortBy] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");
  const [searchTerm, setSearchTerm] = useState("");
  const [envolvidos, setEnvolvidos] = useState([]);

  const { makeRequest } = useAPI();

  const getEnvolvidos = useCallback(async () => {
    let url = `/envolvidos?page=${page}&perPage=${perPage}&sortBy=${sortBy}&sortOrder=${sortOrder}`;

    if (searchTerm) {
      url += `&searchTerm=${searchTerm}`
    }

    const response = await makeRequest(url, "GET");

    if (response.status === 200) {
      setEnvolvidos(response.data.envolvidos);
      setCount(response.data.total);
    }
  }, [page, perPage, sortBy, sortOrder, searchTerm]);

  const deleteEnvolvido = useCallback(
    async (idEnvolvido) => {
      const result = await Swal.fire({
        title: "Tem certeza?",
        text: "Essa ação não pode ser desfeita!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Excluir",
        cancelButtonText: "Cancelar",
      });

      if (result.isConfirmed) {
        const response = await makeRequest(`/envolvidos/${idEnvolvido}`, "DELETE");

        if (response.status === 200) {
          Swal.fire(
            "Excluído!",
            "O envolvido foi removido com sucesso.",
            "success"
          );
          getEnvolvidos();
        } else {
          Swal.fire("Erro!", "Não foi possível excluir o envolvido.", "error");
        }
      }
    },
    [getEnvolvidos]
  );

  const handleSearch = useCallback(() => {
    getEnvolvidos();
  }, [getEnvolvidos]);

  useEffect(() => {
    getEnvolvidos();
  }, [getEnvolvidos]);

  return (
    <JumboContentLayout
      header={
        <HeaderPages
          title={"Envolvidos"}
          buttonHref={"/envolvido"}
          buttonTitle={"Criar envolvido"}
          hasButton={true}
        />
      }
    >
      <PagesFiltersToolsBar
        value={searchTerm}
        setValue={setSearchTerm}
        onSearch={handleSearch}
      />

      {envolvidos && envolvidos.length > 0 ? (
        envolvidos.map((envolvido) => <EnvolvidosListCard key={envolvido.id} envolvido={envolvido} deleteEnvolvido={deleteEnvolvido}  />)
      ) : (
        <EmptyListWarning />
      )}

      <PaginationComponent
        count={count}
        page={page}
        perPage={perPage}
        sortBy={sortBy}
        sortOrder={sortOrder}
        setPage={setPage}
        setPerPage={setPerPage}
        setSortBy={setSortBy}
        setSortOrder={setSortOrder}
      />
    </JumboContentLayout>
  );
};

export default React.memo(Envolvidos);
